<template>
    <div>
        <b-row class="justify-content-md-center h-100" style="margin-top:20px;margin-bottom:20px;">
            <b-col v-for="(bloc,index) in content" :key="index" cols="6" xs="6" sm="6" md="2" style="margin-bottom:10px;">
                <div class="inner_recap_bloc align_center">
                    <p class="recap_bloc_icon"><v-icon :name="bloc.icon" scale="2"></v-icon></p>
                    <p class="recap_bloc_title">{{bloc.title}}</p>
                    <p class="recap_bloc_value">{{bloc.value}}</p>
                </div>
            </b-col>
        </b-row>
    </div>
</template>

<script>
    export default {
        props:["content"],
    }
</script>

<style lang="scss" scoped>

</style>